/**
 * A plan link's decision — open it now, or remember it for the sign-in that follows — must not
 * be taken while the persisted session is still being restored. A notice tapped on a cold
 * start reaches the SPA before the secure store has answered: the shell retains the tap until
 * the listener attaches, which on Android came a few milliseconds ahead of the restore
 * (2026-09-15, ADR-030 §6) — deciding on the render's `null` sent the user to the plan list and
 * left a stale return target for the next sign-in. So the link waits for the restore to settle;
 * a warm app's restore settled long ago and the link is followed at once. A restore that failed
 * counts as no session.
 */
export async function followPlanLink(
  planId: string,
  restored: Promise<unknown>,
  signedIn: () => boolean,
  open: (planId: string) => void,
  remember: (planId: string) => Promise<void>,
): Promise<void> {
  await restored.catch(() => undefined);
  if (signedIn()) open(planId);
  else await remember(planId);
}
